/**
 * RNAPI 2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RnOrganizationAddressesVM } from "../models/./organizationAddressesVM-d";
import { RnPaymentOnFileVM } from "../models/./paymentOnFileVM-d";

export class RnOrganizationPaymentOnFileVM {
  OrganizationID?: number;
  OrganizationName?: string | null;
  NextBillDate?: string;
  NextBillAmount?: string | null;
  BillingAddress?: RnOrganizationAddressesVM;
  PaymentMethods?: Array<RnPaymentOnFileVM> | null;
  LastBillDate?: string;
  NextBillEndDate?: string;
  DisableACH?: boolean | null;
}
